import { createFileRoute } from '@tanstack/react-router';

import { getFacultyOptions } from '@/module/Faculty/model/FacultyQuery';

export const Route = createFileRoute('/_auth/administration/_administration/faculty/_faculty/$facultyId/_layout')({
  loader: async ({ params: { facultyId }, context: { queryClient } }) => {
    const faculty = await queryClient.ensureQueryData(getFacultyOptions(facultyId));

    return {
      faculty,
      crumb: faculty.name,
    };
  },
});
